<template>
  <Teleport to="body">
    <div v-if="visible === true" class="fixed inset-0 z-[220] flex items-center justify-center bg-black bg-opacity-50 px-4 py-6" @click="emitClose">
      <div class="w-full max-w-5xl rounded-xl bg-base-100 shadow-2xl" @click.stop>
        <div class="flex items-center justify-between border-b border-base-300 px-6 py-4">
          <h3 class="text-lg font-bold" :style="labelStyle">{{ titleText }}</h3>
          <button type="button" class="btn btn-ghost btn-sm" @click="emitClose">{{ closeText }}</button>
        </div>
        <div class="max-h-[75vh] overflow-y-auto px-6 py-5">
          <p class="text-sm opacity-70" :style="labelStyle">{{ descriptionText }}</p>
          <div v-if="channels.length > 0" class="flex flex-wrap -m-2 mt-2">
            <div v-for="channel in channels" :key="channel.id" class="w-full md:w-1/2 xl:w-1/3 p-2">
              <div class="h-full rounded-2xl border border-base-300 bg-base-100 p-4">
                <div class="flex items-center justify-between" :class="isRtl === true ? 'flex-row-reverse' : ''">
                  <span class="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-base-200">
                    <Icon :icon="channel.icon" class="h-6 w-6" />
                  </span>
                  <button type="button" class="btn btn-sm" @click="emitOpen(channel.id)">{{ channel.actionLabel }}</button>
                </div>
                <div class="mt-4" :style="labelStyle">
                  <div class="font-semibold">{{ channel.label }}</div>
                  <div v-if="resolveChannelValue(channel).length > 0" class="mt-2 text-base font-bold" :style="valueStyle">{{ resolveChannelValue(channel) }}</div>
                  <div class="mt-2 text-sm opacity-70">{{ channel.description }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="py-8 text-center text-sm opacity-70" :style="labelStyle">{{ t('aiChatAgentSetup.openAgent.noAvailableChannels', 'No openable deployment channel is connected for this agent.') }}</div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import { Icon } from '@iconify/vue/dist/offline';
import { useI18n } from '@/i18n';

const props = defineProps({
  visible: { type: Boolean, default: false },
  isRtl: { type: Boolean, default: false },
  channels: { type: Array, default: () => [] },
  title: { type: String, default: '' },
  description: { type: String, default: '' }
});

const emit = defineEmits(['close', 'open']);
const { t } = useI18n();

const labelStyle = computed(() => props.isRtl === true ? { direction: 'rtl', textAlign: 'right' } : { direction: 'ltr', textAlign: 'left' });
const valueStyle = computed(() => props.isRtl === true ? { direction: 'ltr', textAlign: 'right' } : { direction: 'ltr', textAlign: 'left' });
const titleText = computed(() => props.title !== '' ? props.title : t('aiChatAgentSetup.openAgent.title', 'Open Agent'));
const descriptionText = computed(() => props.description !== '' ? props.description : t('aiChatAgentSetup.openAgent.description', 'Choose where to open this agent.'));
const closeText = computed(() => t('aiChatAgentSetup.buttons.close', 'Close'));

function emitClose() {
  emit('close');
}

function emitOpen(channelId) {
  emit('open', channelId);
}

function resolveChannelValue(channel) {
  if (channel !== null && channel !== undefined && typeof channel.value === 'string') {
    return channel.value.trim();
  }
  return '';
}
</script>
